<template>
  <div class="tab-pane" role="tabpanel" aria-labelledby="home-tab">
    <div class="row mb-3 mt-3">
      <div class="col-md-3">
        <b-button-group>
          <b-button variant="outline-danger">
            <input
              v-model="selectAll"
              type="checkbox"
              @change="selectItemAll(selectAll)"
            />
          </b-button>
          <b-button
            variant="outline-danger"
            type="button"
            :disabled="recordIds.length == 0"
            @click="multiDelete" v-if="$role=='super_admin'"
          >
            <i class="fa fa-trash" />
            {{ $t("site.bulk_delete") }}
          </b-button>
        </b-button-group>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <input
            v-model="search"
            type="text"
            autofocus
            class="form-control"
            :placeholder="$t(`site.search`)"
            @input="(val) => searchChange(val)"
          />
        </div>
      </div>
      <div class="col-3">
        <div class="float-md-right pt-1">
          <span class="text-muted text-small mr-1 mb-2">
            {{ from }}:{{ to }}
          </span>

          <b-dropdown
            id="ddown2"
            right
            :text="`${perPage}`"
            variant="outline-warning"
            size="xs"
          >
            <b-dropdown-item
              v-for="(size, index) in [5, 10, 20, 50, 100]"
              :key="index"
              @click="changePageSize(size)"
              >{{ size }}</b-dropdown-item
            >
          </b-dropdown>
          <span class="text-muted mr-1 mb-2"> of {{ total }}</span>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 overflow-auto">
        <b-table :stacked="($mobile==1)" 
          bordered
          striped
          hover
          ref="table"
          class="vuetable"
          sort-by="id"
          sort-desc="true"
          :current-page="currentPage"
          :fields="bootstrapTable.fields"
          :items="dataProvider"
        >
          <template #cell(checkbox)="data">
            <label class="kt-checkbox kt-checkbox--single kt-checkbox--solid">
              <input
                v-model="recordIds"
                type="checkbox"
                :value="data.item.id"
                @change="selectItem(data)"
              />
              <span />
            </label>
          </template>
          <template #cell(user)="row">
            {{ row.item.user.first_name + " " + row.item.user.last_name }}
          </template>
          <template #cell(status)="row">
            {{ row.item.meta.status }}
          </template>
          <template #cell(start_date_time)="row">
            {{ getDate(row.item.start_date_time) }}
          </template>
          <template #cell(created_at)="row">
            {{ getDate(row.item.start_date_time) }}
          </template>
          <template #cell(edit)="data">
            <b-btn
              v-if="user.account_type == 'student'"
              :href="
                serverConnect + 'connect/app/live/meetings/' + data.item.uuid
              "
            >
              <i class="fas fa-sign-in-alt"></i>
              {{ $t("meeting.join_meeting") }}</b-btn
            >
            <b-dropdown text="Actions" variant="gradient-info" v-else>
              <b-dropdown-item
                :href="
                  serverConnect + 'connect/app/live/meetings/' + data.item.uuid
                "
              >
                <i class="fas fa-sign-in-alt"></i>
                {{ $t("meeting.join_meeting") }}
              </b-dropdown-item>
              <b-dropdown-divider />
              <b-dropdown-item @click="editItem(data)">
                <i class="fa fa-edit" /> Edit</b-dropdown-item
              >
              <b-dropdown-item  @click="deleteItem(data)" v-if="$role=='super_admin'">
                <i class="fa fa-trash" />Delete</b-dropdown-item
              >
            </b-dropdown>
          </template>
        </b-table>
        <div v-if="load" class="lds-ripple-bk justify-content-center">
          <div />
          <div />
        </div>
        <br />
        <hr />
        <b-pagination
          v-model="currentPage"
          align="right"
          class="dataTables_paginate paging_simple_numbers pagination-warning"
          :total-rows="totalRows"
          :per-page="perPage"
        >
          <template v-slot:next-text>
            <i class="fas fa-angle-left" />
          </template>
          <template v-slot:prev-text>
            <i class="fas fa-angle-right" />
          </template>
          <template v-slot:first-text>
            <i class="fas fa-step-forward" />
          </template>
          <template v-slot:last-text>
            <i class="fas fa-step-backward" />
          </template>
        </b-pagination>

        <!-- end of table -->
      </div>
      <!-- end of col -->
    </div>
    <!-- end of row -->
  </div>
</template>

<script>
import controller from "../../../../Controllers/ConnectController";
import config from "../../../../config/config";
import Auth from "@/Apis/Auth";

export default {
  name: "CountriesDataTable",
  props: ["items", "editItem"],
  computed: {
    tabIndex() {
      return this.$parent.$parent.$parent.tabIndex;
    },
  },
  data() {
    return {
      bootstrapTable: {
        selected: [],
        selectMode: "multi",
        fields: [
          { key: "checkbox", label: "", sortable: false },

          {
            key: "title",
            label: this.$i18n.t("meeting.props.title"),
            sort: "title",
            transformer: "limitWords",
            tdClass: "td-ellipsis max-width-250px",
          },
          {
            key: "user",
            label: this.$i18n.t("meeting.host"),
          },

          {
            key: "type",
            label: this.$i18n.t("meeting.props.type"),
            transformer: "objectWithName",
          },

          {
            key: "status",
            label: this.$i18n.t("meeting.props.status"),
          },
          {
            key: "start_date_time",
            label: this.$i18n.t("meeting.props.scheduled_on"),
            sort: "start_date_time",
            transformer: "datetime",
          },

          {
            key: "period",
            label: this.$i18n.t("meeting.props.estimated_period"),
          },
          {
            key: "created_at",
            label: this.$i18n.t("site.created"),
            sort: "created_at",
            transformer: "datetime",
          },

          {
            key: "edit",
            label: "",
            tdClass: "actions-dropdown-wrapper",
          },
        ],
      },
      data: {},
      selectAll: false,
      serverConnect: config.serverConnect,
      currentPage: 1,
      select: [],
      page: 1,
      perPage: 5,
      search: "",
      from: 0,
      total: 0,
      totalRows: 0,
      to: 0,
      lastPage: 0,
      load: false,
      apiParams: {},
      params: {},
      recordIds: [],
      user: Auth.USER,
    };
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    getDate(sDate) {
      const date = new Date(sDate);
      return date.toLocaleString();
    },
    async dataProvider(ctx) {
      this.load = true;
      this.params = ctx;
      const data = await new controller().GetAll(this.apiParamsConverter());
      this.currentPage = data.current_page;
      this.perPage = data.per_page;
      this.totalRows = data.total;
      this.from = data.from;
      this.to = data.to;
      this.total = data.total;
      this.data = data.data;
      this.load = false;
      return data.data;
    },
    apiParamsConverter() {
      const apiParams = { per_page: this.perPage };
      if (this.params.currentPage >= 1) {
        apiParams.page = this.params.currentPage;
      }
      if (this.params.sortBy && this.params.sortBy.length > 0) {
        apiParams.sort = `${this.params.sortBy}|${
          this.params.sortDesc ? "desc" : "asc"
        }`;
      }
      if (this.params.filter && this.params.filter.length > 0) {
        // Optional
      }
      if (this.search !== "") {
        apiParams.search = this.search;
      }
      let eduProgramId = localStorage.getItem("eduProgram");

      if (Auth.USER.account_type == "student") {
        let room = Auth.ROOM.find((a) => a.edu_program_id == eduProgramId);
        apiParams.room_id = room.id;
      } else if (Auth.USER.account_type == "teacher")
        apiParams.room_id = localStorage.getItem("room");
      return apiParams;
    },
    changePageSize(perPage) {
      this.page = 1;
      this.perPage = perPage;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    searchChange() {
      if (this.search.length == 0) {
        this.dataProvider(this.params);
        this.$refs.table.refresh();
      }
      if (this.search.length < 2) return;
      this.page = 1;
      this.dataProvider(this.params);
      this.$refs.table.refresh();
    },
    selectItemAll(select) {
      this.recordIds = [];
      if (select) {
        console.log(this.data);
        this.data.forEach((element) => {
          this.recordIds.push(element.id);
        });
      }
    },
    deleteItem(data) {
      new controller().Delete(data.item.id, this.$refs.table);
    },
    multiDelete() {
      new controller().Delete(0, this.recordIds, this.$refs.table);
    },
  },
  watch: {
    tabIndex() {
      if (this.tabIndex == 0) {
        this.$refs.table.refresh();
      }
    },
  },
};
</script>
